import * as THREE from "three";
import TexturedGeoMesh from "./TexturedGeoMesh";

/**
 * Creates a photosphere with the given image
 * @example
 * let photoSphere = new PhotoSphere(image);
 * scene.add(photoSphere);
 */
export default class PhotoSphere extends TexturedGeoMesh {
  imageFov;
  /**
   * Creates a photosphere based on the given URL
   *
   * @param player
   * @param {object} image - image object containing full and optional low url
   * @param loadedCallback
   * @param promiseCallback
   * @param stereo
   * @param lowRes
   */
  constructor(
    player,
    image,
    loadedCallback = () => {},
    promiseCallback = () => {},
    stereo,
    lowRes = true,
  ) {
    const geometry = new THREE.SphereBufferGeometry(600, 100, 100);
    super(player, geometry, "basic", () => {}, -180);

    this.imageFov = image.fov ?? null;

    this.material.side = THREE.DoubleSide;
    this.flipTexture = true;
    this.image = image;
    this.stereo = stereo;

    let prom = this.loadTexture(image, true, loadedCallback, stereo, lowRes);
    promiseCallback(prom);
  }

  afterTransition() {
    if (this.player) {
      this.player.resetControls(false);
    }
  }

  /**
   *
   * @param copyRotation
   * @returns {null}
   */
  projectSphere(copyRotation = false) {
    // return null; // object is already a sphere
    return super.projectSphere(false);
  }
}
